import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  FileSparePartRequestLine,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.sparePart}files/${COMMON_QUERY_PARAMS.FILE_ID}/requestLines`;

export interface GetFileSparePartRequestLinesRequestArgs {
  fileId: string;
}

export const getFileSparePartRequestLinesRequest = ({
  fileId,
}: GetFileSparePartRequestLinesRequestArgs): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.FILE_ID, fileId),
  config: { method: SUPPORTED_METHODS.GET },
});

export const getFileSparePartRequestLinesQuery = async (
  payload: GetFileSparePartRequestLinesRequestArgs,
): Promise<BackResponse<FileSparePartRequestLine[]> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<FileSparePartRequestLine[]>>(
      getFileSparePartRequestLinesRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
